/**
* Process Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Process Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'process-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let currentTimeout = null;
      const componentEl = document.querySelector( COMPONENT.selector() );

      if ( componentEl ) {
        const observer = new IntersectionObserver(
            function( entries ) {
              entries.forEach( function( entry ) {
                if ( entry.isIntersecting ) {
                  initOrDestroyTimer();
                  observer.disconnect();
                }
              } );
            },
            {threshold: 0.1},
        );
        observer.observe( componentEl );
      }

      function loadNextStep( currentStep ) {
        let nextStep = parseInt( currentStep ) + 1;

        if ( $( '.process-content__step[data-step="' + nextStep + '"]' ).length == 0 ) {
          nextStep = 1;
        }

        // Clear any existing timer
        if ( currentTimeout ) {
          clearTimeout( currentTimeout );
          currentTimeout = null;
        }

        const video = $( '.process-content__video[data-step="' + nextStep + '"] video' );

        if ( video.length ) {
          video[0].load();

          $( video ).on( 'loadeddata', function() {
            $( '.process-content__step:not([data-step="' + nextStep + '"]), .process-content__video:not([data-step="' + nextStep + '"])' ).removeClass( 'is-active' );
            $( '.process-content__step[data-step="' + nextStep + '"], .process-content__video[data-step="' + nextStep + '"]' ).addClass( 'is-active' );
          } );
        } else {
          $( '.process-content__step:not([data-step="' + nextStep + '"]), .process-content__video:not([data-step="' + nextStep + '"])' ).removeClass( 'is-active' );
          $( '.process-content__step[data-step="' + nextStep + '"], .process-content__video[data-step="' + nextStep + '"]' ).addClass( 'is-active' );
        }

        const duration = parseInt( $( '.process-content__step[data-step="' + nextStep + '"]' ).attr( 'data-duration' ) ) * 1000;

        currentTimeout = setTimeout( function() {
          loadNextStep( nextStep );
        }, duration );
      }

      $( '.process-content__step .process-content__step-trigger' ).on( 'click', function() {
        const clickedStep = parseInt( $( this ).closest( '.process-content__step' ).attr( 'data-step' ) ) - 1;
        loadNextStep( clickedStep );
      } );

      function initOrDestroyTimer() {
        if ( window.innerWidth >= 1024 ) {
          loadNextStep( 0 );
        } else {
          clearTimeout( currentTimeout );
          currentTimeout = null;
          $( '.process-content__step, .process-content__video' ).removeClass( 'is-active' );
        }
      }

      // const debouncedInitOrDestroyTimer = new app.components.common.Debounce( initOrDestroyTimer, 500 );

      // // Update on window resize
      // $( window ).on( 'resize', function() {
      //   debouncedInitOrDestroyTimer.run();
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'process-content', COMPONENT );
} )( app );
